module.exports = __webpack_public_path__ + "logo.35d42dda745bf91b7a1c.png";


//////////////////
// WEBPACK FOOTER
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/assets/img/logo.png
// module id = ../../../../../src/assets/img/logo.png
// module chunks = styles